import { CompareListStatusItem, WishlistCheckboxItem } from '@navi-toolbox/ui-components';
import { ReviewsErrorNotification } from 'features/product-reviews/components/pdp-reviews-pagination';
import { OnlineOrderErrorNotification } from 'features/product-info/components/online-order-only-message';
import { CopySkuNotification } from 'features/product-info/components/pdp-product-title';
import { ReviewFormErrorNotification } from 'features/review-form/review-form-statefull';
import { NotificationTemplates } from './types';

export const notificationTemplateFactory = {
  [NotificationTemplates.WishList]: WishlistCheckboxItem,
  [NotificationTemplates.Compare]: CompareListStatusItem,
  [NotificationTemplates.ReviewsError]: ReviewsErrorNotification,
  [NotificationTemplates.OnlineOrderError]: OnlineOrderErrorNotification,
  [NotificationTemplates.CopySKU]: CopySkuNotification,
  [NotificationTemplates.ReviewFormError]: ReviewFormErrorNotification,
};
